"use client";

import * as React from "react";
import { AttendeeChip } from "./AttendeeChip";

export interface AttendeeChipsProps {
  emails: string[];
  names?: Record<string, string>; // Map of email to name
  onRemove?: (email: string) => void;
  className?: string;
  variant?: "default" | "secondary" | "outline" | "destructive";
  size?: "sm" | "md" | "lg";
  showRemoveButton?: boolean;
  clickable?: boolean;
  disabled?: boolean;
  ContactPopoverComponent?: React.ComponentType<{ name: string; email: string; children: React.ReactNode }>;
}

export function AttendeeChips({ 
  emails, 
  names = {},
  onRemove, 
  className = "",
  variant = "secondary",
  size = "md",
  showRemoveButton = false,
  clickable = true,
  disabled = false,
  ContactPopoverComponent
}: AttendeeChipsProps) {
  if (emails.length === 0) return null;
  
  return (
    <div className={`flex flex-wrap gap-2 ${className}`}>
      {emails.map((email) => (
        <AttendeeChip
          key={email}
          email={email}
          name={names[email]}
          onRemove={onRemove}
          variant={variant}
          size={size}
          showRemoveButton={showRemoveButton}
          clickable={clickable}
          disabled={disabled}
          ContactPopoverComponent={ContactPopoverComponent}
        />
      ))}
    </div>
  );
}

export default AttendeeChips;


